<template>
  <div class="d-flex flex-wrap align-center col-2 p-20" style="gap: 16px; margin-top: 50px">
    <v-select
        v-model="filtros.tipo"
        :items="tiposComTodos"
        label="Tipo"
        dense
        outlined
        clearable
    />

    <v-select
        v-model="filtros.fornecedor"
        :items="fornecedores"
        label="Fornecedor"
        dense
        outlined
        clearable
    />

    <v-select
        v-model="filtros.situacao"
        :items="situacoes"
        label="Situação"
        dense
        outlined
        clearable
    />

    <v-btn color="primary p-20"
           class="px-6" depressed
           @click="$emit('pesquisar', filtros)"
           style="min-width: 80px; max-width: 100px; margin-left: 0"
    >
      PESQUISAR
    </v-btn>

    <v-btn outline
           color="botao-cancelar-color p-20 mr-2"
           class="px-6" depressed
           @click="limpar"
           style="min-width: 80px; max-width: 100px; margin: 0"
    >
      LIMPAR
    </v-btn>
  </div>
</template>

<script>
export default {
    name: 'FiltroDocumentos',
    props: {
        fornecedores: Array,
        tipos: Array,
        situacoes: Array
    },
    data() {
        return {
            filtros: {
                tipo: null,
                fornecedor: null,
                situacao: null
            }
        }
    },
    computed: {
        tiposComTodos() {
            return ['Todos', ...this.tipos]
        }
    },
    methods: {
        limpar() {
            this.filtros = {
                tipo: null,
                fornecedor: null,
                situacao: null
            }
            this.$emit('limpar')
        }
    }
}
</script>
<style>
.p-20{
  padding: 20px;
}


</style>
